<template>
    <BaseFacets ref="facets" :rawFacetData="publicationsFacetData" :facetCriteria="passedFacetCriteria" :facetError="facetError" :facetLoader="facetLoader" :sidebarNavigation="false" :omitCount="true" v-on:update-search="updateSearch" v-on:clear-selections="clearSelections"
    v-on:reinit-search="reinitSearch"></BaseFacets>
</template>
<script>
    import {mapGetters, mapActions} from 'vuex';
    import BaseFacets from '@/components/global/BaseFacets.vue';
    // import globalMixins from '@/globalMixins';

    export default {
        name: 'facets',
        components: {
            BaseFacets
        },
        data: function () {
            return {
                // facetData: null,
                defaultFacetCriteria: {},
                facetError: false,
                facetLoader: false,
                updateProjectSearchResultsTimeout: null
            };
        },
        computed: {
            ...mapGetters([
                'searchMeta',
                'publicationsFacetCriteria',
                'publicationsFacetData',
                'publicationResults'
            ]),
            passedFacetCriteria: function () {
                return Object.assign(this.defaultFacetCriteria, this.publicationsFacetCriteria);
            }
        },
        mounted () {
            if ((this.searchMeta && !this.searchMeta.search_id) || !this.$route.params.search_id) {
                this.$router.push({ path: '/' });
            } else {
                this.facetError = false;

                if (!this.publicationsFacetData) {
                    this.facetLoader = true;
                    this.getPubSearchFacets(false);
                }
            }
        },
        methods: {
            ...mapActions([
               'setPublicationsFacetData',
               'setPublicationsFacetCriteria',
               'updatePublicationsFacetCriteria',
               'setPublicationResults'
            ]),
            getPubSearchFacets (changeCriteria) {
                if (this.$route.query) {
                    this.$parent.parseFacetFiltersFromURL();
                }

                if (this.$route.name === 'publication-search-results') {
                    this.loadingPubFacets = true;
                    this.loadPubSearchFacets();
                } else {
                    this.setPublicationsFacetData(null);
                    this.setPublicationsFacetCriteria(null);
                }
            },
            loadPubSearchFacets () {
                var self = this,
                    data = this.publicationResults.facet_results,
                    facetData = {
                        facets: [
                            {
                                name: 'publication_years',
                                display: 'Publication Years',
                                values: []
                            }
                        ],
                        search_id: this.$route.params.search_id
                    };

                this.facetLoader = false;
                if (!data.status) {
                    data = copyData(data);

                    facetData.facets[0].values = data.map(datum => {
                        return {
                            value: datum.pub_year.toString(),
                            display: datum.pub_year.toString(),
                            count: datum.total_publications
                        }
                    });

                    this.setPublicationsFacetData(facetData);
                   
                    if (!this.publicationsFacetCriteria) {
                        this.setPublicationsFacetCriteria(facetData);
                        this.$parent.parseFacetFiltersFromURL();
                    }
                } else {
                    this.setPublicationsFacetData(null);
                    this.setPublicationsFacetCriteria(null);
                    this.facetError = true;
                }
            }, 
            reinitSearch () {
                this.$nextTick(() => {
                    this.$parent.$refs.matchmakerCriteria.search();
                });
            },
            updateSearch (newFacetCriteria, timeout) {
                var facetToQueryStr = '';

                if (!timeout) {
                    timeout = 500;
                }

                this.facetError = false;
                this.updatePublicationsFacetCriteria(newFacetCriteria);

                this.updateProjectSearchResultsTimeout = setTimeout(() => {
                    this.reloadSearch();
                }, timeout);
            },
            clearSelections (newFacetCriteria) {
                this.updatePublicationsFacetCriteria(newFacetCriteria);

                this.reloadSearch();
            },
            reloadSearch () {
                if (this.$parent.scrollToResultsTop) {
                    this.$parent.scrollToResultsTop();
                }

                this.$parent.clearSearchResults({resetFacets: false});
                this.$parent.isPageLoading = true;
                this.$parent.publicationResultsTable.offset = 0;
                this.$parent.publicationResultsTable.isLoading = true;
                this.$parent.getPublicationSearchResults(false);
            },
            resetFacets () {
                this.setPublicationsFacetData(null);
                this.setPublicationsFacetCriteria(null);
            },
            generateQueryString () {
                return this.$refs.facets.generateQueryString();
            }
        }
  }

</script>

<style lang="scss" scoped>
</style>
